import { render } from "./PaymentFailed.vue?vue&type=template&id=5d4a7067&scoped=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"

import "./PaymentFailed.vue?vue&type=style&index=0&id=5d4a7067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4a7067"]])

export default __exports__